var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommunity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "93px",
    height: "108px",
    viewBox: "0 0 93 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22-Copy-2",
    transform: "translate(53.171573, 54.414214) rotate(-45.000000) translate(-53.171573, -54.414214) translate(0.171573, 0.414214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,12 C32.699471,12 13,31.699471 13,56",
    id: "Path",
    stroke: "#304FFE",
    strokeWidth: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1715729,12 C71.0801829,12 53.1715729,29.90861 53.1715729,52",
    id: "Path-Copy",
    stroke: "#00CC69",
    strokeWidth: 25,
    transform: "translate(73.171573, 32.000000) rotate(90.000000) translate(-73.171573, -32.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#304FFE",
    cx: 54.0857864,
    cy: 12.9142136,
    r: 12.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,55 C30.90861,55 13,72.90861 13,95",
    id: "Path-Copy-3",
    stroke: "#00B0FF",
    strokeWidth: 25,
    transform: "translate(33.000000, 75.000000) rotate(270.000000) translate(-33.000000, -75.000000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#00B0FF",
    cx: 12.5,
    cy: 55.5,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#00B0FF",
    cx: 50.136039,
    cy: 94.9644661,
    r: 12.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#00CC69",
    cx: 93.136039,
    cy: 49.7218254,
    r: 12.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.99e9df0ed8d881f22f2904d311e31438.svg";
export { ForwardRef as ReactComponent };